var Backbone = require('backbone')

var TabModel = Backbone.Model.extend({

})
module.exports = TabModel



// WEBPACK FOOTER //
// ./js/behaviors/tabs/model.js